var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_svg__path-1",
    d: "M12 10.582 21.467 0 24 2.886Q12.157 16.012 12 16q-.163.006-12-13.114L2.533 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down_svg__chevron-down",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down_svg__icons/chevron-down-copy",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron-down_svg__path-1",
    id: "chevron-down_svg__Shape",
    fill: "#000",
    fillRule: "nonzero"
  })))));
};
export default SvgChevronDown;